import { useEffect, useState } from "react";
import AnywhereCachedDeals from "@/components/landing/AnywhereCachedDeals";
import DeparturePicker from "@/components/landing/DeparturePicker";
import { api } from "@/lib/api";

export default function PrefetchedDeals() {
  const params = new URLSearchParams(window.location.search);
  const preferred = params.get("origin") || "BOM";
  const [origin, setOrigin] = useState(/^[a-z]{3}$/i.test(preferred) ? preferred.toUpperCase() : "BOM");
  const [metros, setMetros] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    api.get(`/public/flight-deals?origin=${encodeURIComponent(origin)}`, { signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) setMetros(data.metros || []); })
      .catch(() => {});
    return () => controller.abort();
  }, [origin]);
  return <div className="mx-auto max-w-6xl space-y-5 px-4 py-8 sm:px-6">
    <DeparturePicker id="prefetched-origin" label="Departure city" origin={origin} originName={metros.find(metro => metro.code === origin)?.name || origin} metros={metros} onChange={setOrigin} />
    <AnywhereCachedDeals origin={origin} selectedDeal={params.get("deal") || ""} />
  </div>;
}
